function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, createContext, useContext } from "react";
import { getCompanyData } from "./api-service";
import { getCookie } from "/services/cookies-service";
import { BIG_BRAIN_VISITOR_ID, EXPERIMENT_VISITOR_ID } from "/constants/cookies";
import { truncateQueryParams } from "utils/url";
const CompanyDataContext = /*#__PURE__*/ createContext("CompanyData");
export const CompanyDataProvider = ({ children })=>{
    const [companyData, setCompanyData] = useState({
        enrichedAttempted: false
    });
    useEffect(()=>{
        const setData = function() {
            var _ref = _async_to_generator(function*() {
                var _window_location, _window;
                const pagePath = truncateQueryParams((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href);
                const visitorId = getCookie(BIG_BRAIN_VISITOR_ID);
                const experimentVisitorId = getCookie(EXPERIMENT_VISITOR_ID);
                const clearbitResponse = yield getCompanyData(pagePath, visitorId, experimentVisitorId);
                setCompanyData(_object_spread_props(_object_spread({}, clearbitResponse), {
                    enrichedAttempted: true
                })); // Failed enrichments will not have data field
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ _jsx(CompanyDataContext.Provider, {
        value: companyData,
        children: children
    });
};
export const useCompanyData = ()=>{
    const companyData = useContext(CompanyDataContext);
    return companyData;
};
